import React from 'react';
import {connect} from 'react-redux';

import {AppState} from '../Store';

export interface OCProgramProps {
  startProgram: (program: string, args?: string[]) => Promise<void>;
  program: string;
}

function OCProgram({startProgram, program}: OCProgramProps) {
  const launch = () => {
    startProgram(program);
  };

  return (
    <div className="oc-link" onClick={launch}>{program.replace(/([A-Z]+|[0-9]+)/g, ' $1').trim()}</div>
  );
}

const mapStateToProps = (state: AppState) => ({
  startProgram: state.auth.officeCompanionService.startProgram,
});

export default connect(mapStateToProps)(OCProgram);
